/**
 * ProtectedRoute Component for Client App
 *
 * Wrapper around shared ProtectedRoute that integrates with local AuthContext.
 * Используется для защиты маршрутов в Client приложении.
 *
 * @example
 * import ProtectedRoute from '../components/ProtectedRoute';
 *
 * <ProtectedRoute requireAuth requireB2B>
 *   <B2BDashboard />
 * </ProtectedRoute>
 */
import LoadingSpinner from '../../../shared/components/LoadingSpinner/LoadingSpinner.js';
import SharedProtectedRoute from '../../../shared/components/ProtectedRoute/ProtectedRoute.js';
import { useAuth } from '../context/AuthContext';

/**
 * Client-specific ProtectedRoute wrapper
 *
 * Automatically passes AuthContext state to the shared component.
 */
const ProtectedRoute = ({
  children,
  requireAuth = true,
  requireB2B = false,
  requireAdmin = false,
  ...otherProps
}) => {
  const { isAuthenticated, isLoading, hasB2BAccess, isAdmin, user } = useAuth();

  // Build authState object for shared component
  const authState = {
    isAuthenticated,
    isLoading,
    hasB2BAccess,
    isAdmin,
    user,
  };

  return (
    <SharedProtectedRoute
      authState={authState}
      requireAuth={requireAuth}
      requireB2B={requireB2B}
      requireAdmin={requireAdmin}
      LoadingComponent={LoadingSpinner}
      {...otherProps}
    >
      {children}
    </SharedProtectedRoute>
  );
};

export default ProtectedRoute;
